/* ==========================================================================
   KCV2 gerelateerde tabs

   Wisselt categorie / merk / type. Haalt ontbrekende lijsten op via de
   helper-sectie. Verbergt een tab onder 4 producten op voorraad.
   ========================================================================== */

(function () {
  'use strict';

  if (customElements.get('kcv2-related-tabs')) return;

  class Kcv2RelatedTabs extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === '1') return;
      this.dataset.ready = '1';

      this.min = parseInt(this.dataset.min, 10) || 4;
      this.limit = parseInt(this.dataset.limit, 10) || 10;
      this.skipId = this.dataset.skipId || '';
      this.randomize = this.dataset.randomize === 'true';
      this.sectionId = this.dataset.section || '';
      this.searchUrl = this.dataset.searchUrl || '/search';

      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[data-kcv2-rel-tab]'));
      this.panels = Array.prototype.slice.call(this.querySelectorAll('[data-kcv2-rel-panel]'));

      this.initTabs();
      this.panels.forEach(this.setupPanel, this);
      this.panels.forEach(function (panel) {
        if (panel.dataset.searchQuery) this.ensureLoaded(panel);
      }, this);
      this.syncVisibility();
      this.observeFit();
    }

    initTabs() {
      var self = this;
      this.tabs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.select(btn.dataset.kcv2RelTab);
        });
        btn.addEventListener('keydown', function (e) {
          var visible = self.tabs.filter(function (tab) { return !tab.hidden; });
          var i = visible.indexOf(btn);
          var next = null;
          if (e.key === 'ArrowRight') next = visible[(i + 1) % visible.length];
          if (e.key === 'ArrowLeft') next = visible[(i - 1 + visible.length) % visible.length];
          if (!next) return;
          e.preventDefault();
          self.select(next.dataset.kcv2RelTab);
          next.focus();
        });
      });
    }

    select(name) {
      this.tabs.forEach(function (btn) {
        var on = btn.dataset.kcv2RelTab === name;
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
        btn.tabIndex = on ? 0 : -1;
      });
      this.panels.forEach(function (panel) {
        panel.hidden = panel.dataset.kcv2RelPanel !== name;
      });
      var panel = this.querySelector('[data-kcv2-rel-panel="' + name + '"]');
      if (panel) {
        this.ensureLoaded(panel);
        Array.prototype.forEach.call(panel.querySelectorAll('img[loading="lazy"]'), function (img) {
          img.loading = 'eager';
        });
      }
    }

    setupPanel(panel) {
      var track = panel.querySelector('[data-kcv2-rel-results]');
      if (track && !track.classList.contains('is-loading')) {
        this.prepareTrack(panel, track);
      } else if (panel.dataset.searchQuery) {
        if (!panel.hidden) this.ensureLoaded(panel);
      }

      var prev = panel.querySelector('[data-kcv2-rel-prev]');
      var next = panel.querySelector('[data-kcv2-rel-next]');
      if (prev) prev.addEventListener('click', function () { this.scrollPanel(panel, -1); }.bind(this));
      if (next) next.addEventListener('click', function () { this.scrollPanel(panel, 1); }.bind(this));
    }

    ensureLoaded(panel) {
      if (panel.dataset.loaded === '1' || !panel.dataset.searchQuery) return;
      if (panel.dataset.loading === '1') return;
      panel.dataset.loading = '1';

      var url = this.searchUrl + '?q=' + encodeURIComponent(panel.dataset.searchQuery) +
        '&type=product&section_id=' + encodeURIComponent(this.sectionId) + '&ose=false';

      var self = this;
      fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (res) { return res.ok ? res.text() : ''; })
        .then(function (html) {
          panel.dataset.loading = '0';
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var source = doc.querySelector('[data-kcv2-rel-results]');
          if (!source) {
            var tpl = doc.querySelector('template');
            if (tpl && tpl.content) source = tpl.content.querySelector('[data-kcv2-rel-results]');
          }
          if (!source) {
            self.hidePanel(panel);
            return;
          }
          self.fillPanel(panel, source);
        })
        .catch(function () {
          panel.dataset.loading = '0';
          self.hidePanel(panel);
        });
    }

    fillPanel(panel, source) {
      var skip = this.skipId;
      var items = Array.prototype.slice.call(source.querySelectorAll('[data-in-stock="true"]'));
      items = items.filter(function (item) {
        return !skip || String(item.getAttribute('data-product-id')) !== String(skip);
      });

      if (items.length < this.min) {
        this.hidePanel(panel);
        return;
      }

      if (this.randomize) {
        for (var i = items.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var tmp = items[i];
          items[i] = items[j];
          items[j] = tmp;
        }
      }
      items = items.slice(0, this.limit);

      var track = panel.querySelector('[data-kcv2-rel-results]');
      if (!track) return;
      track.classList.remove('is-loading');
      track.innerHTML = '';
      items.forEach(function (item) {
        track.appendChild(item);
      });
      panel.dataset.loaded = '1';
      this.prepareTrack(panel, track);
      this.syncVisibility();
    }

    prepareTrack(panel, track) {
      var slides = track.querySelectorAll('.kcv2-rel__slide:not(.kcv2-rel__slide--skel)');
      if (slides.length < this.min) {
        this.hidePanel(panel);
        return;
      }
      if (this.randomize && panel.dataset.shuffled !== '1' && !panel.dataset.searchQuery) {
        var list = Array.prototype.slice.call(slides);
        for (var i = list.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var tmp = list[i];
          list[i] = list[j];
          list[j] = tmp;
        }
        list.forEach(function (item) { track.appendChild(item); });
        panel.dataset.shuffled = '1';
      }
      panel.dataset.loaded = '1';
      this.fitRow();
      this.updateNav(panel);
      track.addEventListener('scroll', function () { this.updateNav(panel); }.bind(this), { passive: true });
    }

    observeFit() {
      var wrap = this.querySelector('.kcv2-rel__wrap');
      if (!wrap) return;
      this.fitRow();
      if (this._fitObserver || typeof ResizeObserver === 'undefined') return;
      this._fitObserver = new ResizeObserver(function () { this.fitRow(); }.bind(this));
      this._fitObserver.observe(wrap);
    }

    fitRow() {
      var wrap = this.querySelector('.kcv2-rel__wrap');
      if (!wrap) return;
      var width = wrap.clientWidth;
      if (width < 80) return;

      var styles = getComputedStyle(this);
      var gap = parseFloat(styles.getPropertyValue('--kcv2-rel-gap')) || 12;
      var target = parseFloat(styles.getPropertyValue('--kcv2-rel-target')) || 218;
      var slop = parseFloat(styles.getPropertyValue('--kcv2-rel-slop')) || 30;
      var current = parseInt(this.dataset.kcv2RelCols, 10) || 0;
      var next = this.colsForWidth(width, gap, target, slop, current);

      if (next === current && this.dataset.kcv2RelFit === '1') return;

      this.dataset.kcv2RelFit = '1';
      this.dataset.kcv2RelCols = String(next);
      wrap.style.setProperty('--kcv2-rel-cols', String(next));
      this.panels.forEach(this.updateNav, this);
    }

    colsForWidth(width, gap, target, slop, current) {
      var minW = target - slop;
      var maxW = target + slop;
      var minCols = 2;
      var maxCols = 12;
      var cardWidth = function (n) {
        return (width - (n - 1) * gap) / n;
      };

      if (current >= minCols) {
        var keep = cardWidth(current);
        if (keep >= minW && keep <= maxW) return current;
      }

      var best = minCols;
      var bestScore = Infinity;
      var n;
      for (n = minCols; n <= maxCols; n++) {
        var size = cardWidth(n);
        if (size <= 0) continue;
        var inRange = size >= minW && size <= maxW;
        var score = (inRange ? 0 : 1000) + Math.abs(size - target);
        if (score < bestScore) {
          bestScore = score;
          best = n;
        }
      }
      return best;
    }

    hidePanel(panel) {
      var name = panel.dataset.kcv2RelPanel;
      panel.hidden = true;
      this.tabs.forEach(function (btn) {
        if (btn.dataset.kcv2RelTab === name) btn.hidden = true;
      });
      this.syncVisibility();
    }

    syncVisibility() {
      var visibleTabs = this.tabs.filter(function (tab) { return !tab.hidden; });
      var tablist = this.querySelector('[role="tablist"]');

      if (visibleTabs.length === 0) {
        /* Geen zichtbare tab is niet hetzelfde als niets te tonen. De
           artikelsectie heeft er helemaal geen, en de productpagina rendert
           de tabrij ook niet zodra er maar één bron overblijft — in beide
           gevallen verdween de hele sectie terwijl het paneel gevuld was.
           Zonder tabs telt dus of er nog een zichtbaar paneel staat. */
        if (this.tabs.length === 0) {
          var gevuld = this.panels.some(function (panel) { return !panel.hidden; });
          if (gevuld) return;
        }
        if (this.closest('.shopify-section')) {
          this.closest('.shopify-section').style.display = 'none';
        } else {
          this.hidden = true;
        }
        return;
      }

      if (tablist) tablist.hidden = visibleTabs.length < 2;

      var selected = visibleTabs.find(function (tab) {
        return tab.getAttribute('aria-selected') === 'true';
      });
      if (!selected) this.select(visibleTabs[0].dataset.kcv2RelTab);
    }

    scrollPanel(panel, dir) {
      var track = panel.querySelector('[data-kcv2-rel-results]');
      var slide = track && track.querySelector('.kcv2-rel__slide');
      if (!track || !slide) return;
      var gap = parseInt(getComputedStyle(track).gap, 10) || 12;
      track.scrollBy({ left: dir * (slide.getBoundingClientRect().width + gap), behavior: 'smooth' });
    }

    updateNav(panel) {
      var track = panel.querySelector('[data-kcv2-rel-results]');
      var prev = panel.querySelector('[data-kcv2-rel-prev]');
      var next = panel.querySelector('[data-kcv2-rel-next]');
      if (!track || !prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 4;
      var overflow = max > 8;
      prev.hidden = !overflow;
      next.hidden = !overflow;
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= max;
    }
  }

  customElements.define('kcv2-related-tabs', Kcv2RelatedTabs);
})();
